import { Diamond } from "@src/types/DiamondDetail";
import {
  getOptimizedImageUrl,
  ImageSizePreset,
} from "@utils/image/imageOptimizer";

export const getImageUrl = (item?: Diamond) => {
  return item?.image_thumb_url || item?.image_url || "";
};

export const getOptimizedGridImageUrl = (item?: Diamond) => {
  const raw = item?.image_thumb_url || item?.image_url || "";
  return getOptimizedImageUrl(raw, ImageSizePreset.GRID);
};

export const getOptimizedListImageUrl = (item?: Diamond) => {
  const raw = item?.image_thumb_url || item?.image_url || "";
  return getOptimizedImageUrl(raw, ImageSizePreset.LIST_THUMB);
};

export const isImageUrlEmptyOrUndefined = (item?: Diamond) => {
  let imageUrl = item?.image_thumb_url || item?.image_url || "";
  return imageUrl === "";
};
